const n = "/api_public/v1/client_booking_engine", E = "EUR", _ = "en";
export {
  n as BOOKING_ENGINE_BASE_URL,
  E as DEFAULT_CURRENCY,
  _ as DEFAULT_LANGUAGE
};
